var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6364 6.19048C15.1455 6.19048 16.3545 4.80794 16.3545 3.09524C16.3545 1.38254 15.1455 0 13.6364 0C12.1273 0 10.9091 1.38254 10.9091 3.09524C10.9091 4.80794 12.1273 6.19048 13.6364 6.19048ZM6.36364 6.19048C7.87273 6.19048 9.08182 4.80794 9.08182 3.09524C9.08182 1.38254 7.87273 0 6.36364 0C4.85455 0 3.63636 1.38254 3.63636 3.09524C3.63636 4.80794 4.85455 6.19048 6.36364 6.19048ZM6.36364 8.25397C4.24545 8.25397 0 9.46111 0 11.8651V13.4127C0 13.9802 0.409091 14.4444 0.909091 14.4444H11.8182C12.3182 14.4444 12.7273 13.9802 12.7273 13.4127V11.8651C12.7273 9.46111 8.48182 8.25397 6.36364 8.25397ZM13.6364 8.25397C13.3727 8.25397 13.0727 8.2746 12.7545 8.30556C12.7727 8.31587 12.7818 8.33651 12.7909 8.34683C13.8273 9.20317 14.5455 10.3484 14.5455 11.8651V13.4127C14.5455 13.7738 14.4818 14.1246 14.3818 14.4444H19.0909C19.5909 14.4444 20 13.9802 20 13.4127V11.8651C20 9.46111 15.7545 8.25397 13.6364 8.25397Z",
    fill: "#8E99A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/UsersIcon.a2ccfe678f25340c5fbd381467e177a7.svg";
export { ForwardRef as ReactComponent };